import { DirectionRouteMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/shared/DirectionRouteMarkerStyleSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { IRouteV2WorldMarker } from 'react-give-me-map/dist/utils/world/worldTypes';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IRouteV2WorldMarker;
}

export const RouteMarkerSidebar = (props: Props): JSX.Element => {
    return (
        <S_RouteMarkerSidebar className={props.className}>
            <DirectionRouteMarkerStyleSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_RouteMarkerSidebar>
    );
};

const S_RouteMarkerSidebar = styled.div``;
